import { API_ENDPOINT } from 'constants/config'
export const OFFICIAL_HOLIDAY_URL = 'https://www8.cao.go.jp/chosei/shukujitsu/gaiyou.html'
export const ACCEPT_INVITATION_ENDPOINT = API_ENDPOINT + '/apiAcceptInvitation'
export const ACCEPT_UPDATE_INVITATION_ENDPOINT = API_ENDPOINT + '/apiAcceptUpdateInvitation'
export const CANCEL_CHECKOUT_ENDPOINT = API_ENDPOINT + '/apiCancelCheckoutWithToken'
export const DELETE_ACCOUNT_ENDPOINT = API_ENDPOINT + '/apiDeleteAccount'
export const FETCH_CANCEL_DEADLINE_ENDPOINT = API_ENDPOINT + '/apiFetchCancelDeadline'
export const FETCH_STAFF_ENDPOINT = API_ENDPOINT + '/apiFetchStaff'
export const FETCH_USERS_BY_GEO = API_ENDPOINT + '/apiFetchUsersByGeo'
export const GENERATE_STORES_GEO_SEARCH = API_ENDPOINT + '/apiGenerateStoresGeoSearch'
export const CREATE_OWN_BRAND_ENDPOINT = API_ENDPOINT + '/apiCreateOwnBrand'
export const INVITE_STAFF_ENDPOINT = API_ENDPOINT + '/apiInviteStaff'
export const MONTHLY_REPORT_ENDPOINT = API_ENDPOINT + '/apiMonthlyReportWithToken'
export const PAYOUT_ENDPOINT = API_ENDPOINT + '/apiPayoutWithToken'
export const PUSH_NOTIFICATION_ENDPOINT = API_ENDPOINT + '/apiSendPushWithToken'
export const REMOVE_STAFF_FROM_STORE_ENDPOINT = API_ENDPOINT + '/apiRemoveStaffFromStore'
export const REGISTER_CARD_ENDPOINT = API_ENDPOINT + '/apiRegisterCard'
export const RETRIEVE_CARD_ENDPOINT = API_ENDPOINT + '/apiRetrieveCard'
export const RETRIEVE_INVOICES_ENDPOINT = API_ENDPOINT + '/apiRetrieveInvoices'
export const RETRIEVE_SUBSCRIPTION_ENDPOINT = API_ENDPOINT + '/apiRetrieveSubscription'
export const RETRIEVE_SCHEDULE_ENDPOINT = API_ENDPOINT + '/apiRetrieveSubscriptionSchedule'
export const UPDATE_STAFF_STORES_ENDPOINT = API_ENDPOINT + '/apiUpdateStaffStores'
